const sortData = (data = {}) =>
  Object.entries(data).sort((a, b) => {
    if (a[0] === 'Other') return 1;
    if (b[0] === 'Other') return -1;

    return b[1] - a[1];
  });

export default sortData;
